import React from "react";
import "./sinResultados.sass";

export default function SinResultados({ componenteActual }) {

    return (
        <div className={`container-calendario-sin-resultados component-${componenteActual}`}>
            <p className="calendario-sin-resultados-texto">No hay eventos con estos ajustes</p>
        </div>
    )
}